module.exports = __webpack_public_path__ + "static/media/report_dev.ab7d670c.svg";